import { fromDateKey } from '@/lib/supabase';

/**
 * `YYYY-MM-DD` → a short, localised day label ("Sep 4"). Built on
 * `fromDateKey()` (parts, never `new Date('2026-09-04')`, which parses as UTC
 * midnight and renders as the day BEFORE in Eastern — CLAUDE.md trap #1).
 * Used by the half-day hints on the request and Log an Absence forms, which
 * echo the range the person typed; the `<input type="date">` beside them
 * already shows localised dates, so a raw ISO string would have been the only
 * one on the page. Falls back to the raw key for anything that is not one.
 */
export function formatDayKey(key: string): string {
  try {
    return fromDateKey(key).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  } catch {
    return key;
  }
}
